module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wasou-hairmake-68859ba6c977411ac86d6ee7e00fcedd.png";